import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { NetworkStatus } from '@cbridge-utils/network';
import { symbolGroupsStoreSelector } from '@cbridge-packages/symbol-groups';
import { buildSymbolGroupsTree } from './_helpers/buildSymbolGroupsTree';

export const coreSymbolGroupsFilterPropsSelector = createCachedSelector(
  [
    path(symbolGroupsStoreSelector).symbolGroups(),
    path(symbolGroupsStoreSelector).networkStatus(),
  ],
  (symbolGroups, networkStatus) => {
    return {
      symbolGroups: buildSymbolGroupsTree(symbolGroups),
      isLoading: networkStatus !== NetworkStatus.Done && networkStatus !== NetworkStatus.Failed,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
